// The web app's version (4.11.55), set at build time from the release tag (scripts/app-version.js):
// "4.11.55", or "4.11.55-3-gabc1234" for a build a few commits after the tag. Shown in the You panel and in
// Report a Problem e-mails, and used by the "A new version is available" banner (NewVersionBanner.js).
export const APP_VERSION = process.env.REACT_APP_VERSION || "";

// The release part only: "4.11.55-3-gabc1234" → "4.11.55".
export const releaseOf = (v) => String(v || "").split("-")[0];

// Offer a refresh when the deployed version (build/version.json) differs from the one running.
// Nothing to compare (local dev, the file missing or unreadable) → no banner.
export function shouldOfferRefresh(running, deployed) {
  const a = String(running || "").trim();
  const b = String(deployed || "").trim();
  return !!a && !!b && a !== b;
}

// The deployed version, or null (never rejects).
export async function fetchDeployedVersion(fetchFn = typeof fetch === "function" ? fetch : null) {
  if (!fetchFn) return null;
  try {
    const res = await fetchFn(`/version.json?t=${Date.now()}`, { cache: "no-store" });
    if (!res || !res.ok) return null;
    const data = await res.json();
    return data && typeof data.version === "string" ? data.version : null;
  } catch (e) {
    return null;
  }
}
